import Image from 'next/image'
import {FC} from 'react'

import {useSuccessPageContent} from '@/content/successPage'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

export const EmailClientLogos: FC = () => {
  const {emailClients} = useSuccessPageContent()

  return (
    <>
      <ul className="list">
        {emailClients.map(({imageSrc, imageAlt, linkHref}) => (
          <li key={imageSrc}>
            <a href={linkHref} className="wrapper" target="_blank" rel="noreferrer">
              <div className="logo">
                <Image
                  src={imageSrc}
                  alt={imageAlt}
                  style={{objectFit: 'contain'}}
                  fill
                  sizes="32px"
                />
              </div>
            </a>
          </li>
        ))}
      </ul>

      <style jsx>{`
        .list {
          display: flex;
          justify-content: center;
          gap: ${theme.spacing[2.5]};
        }
        .wrapper {
          display: block;
          padding: ${theme.spacing[3]};
          border: 1px solid ${theme.palette.gray[200]};
          border-radius: 12px;
        }
        .logo {
          position: relative;
          width: 32px;
          height: 32px;
        }
        @media ${MOBILE_SCREENSIZE} {
          .wrapper {
            padding: ${theme.spacing[2]};
          }
        }
      `}</style>
    </>
  )
}
